import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { postApiLoginAsyn } from "../../Services/PostAPI";
import "../ResetPassword/index.css";

const ForgotPasswordReset = ({ location }) => {
  const hashQuery = window.location.hash.includes("?")
    ? window.location.hash.substring(window.location.hash.indexOf("?"))
    : "";
  const token =
    new URLSearchParams(location?.search).get("token") ||
    new URLSearchParams(hashQuery).get("token") ||
    "";

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setIsError(true);
      setError("Passwords do not match.");
      return;
    }
    if (password.length < 8) {
      setIsError(true);
      setError("Password must be at least 8 characters.");
      return;
    }
    if (!token) {
      setIsError(true);
      setError("Invalid or missing reset link. Please request a new one.");
      return;
    }

    setIsLoading(true);
    setIsSuccess(false);
    setIsError(false);
    setError("");

    try {
      const res = await postApiLoginAsyn("reset-password", { token, password, confirmPassword });
      if (res.status === 200) {
        setIsSuccess(true);
      } else {
        const errBody = await res.json().catch(() => ({}));
        setIsError(true);
        setError(errBody?.detail || errBody?.message || "Failed to reset password. The link may have expired.");
      }
    } catch (err) {
      setIsError(true);
      setError("An error occurred. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="ff-reset-container">
      <div className="ff-reset-box">
        <h3 className="ff-reset-title">Reset Password</h3>
        {isSuccess ? (
          <>
            <div className="alert alert-success">Password updated successfully!</div>
            <Link to="/">Back to Login</Link>
          </>
        ) : (
          <form className="ff-reset-form" onSubmit={handleSubmit}>
            <input
              type="password"
              placeholder="New password"
              className="form-control"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={isLoading}
            />
            <input
              type="password"
              placeholder="Confirm new password"
              className="form-control"
              required
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              disabled={isLoading}
            />
            <Button disabled={isLoading} type="submit" variant="primary">
              {isLoading ? "Updating..." : "Reset Password"}
            </Button>
            {isError && (
              <div className="alert alert-danger mt-3">{error}</div>
            )}
          </form>
        )}
        <div className="mt-3">
          <Link to="/forgot-password">Request a new link</Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordReset;
